export class OffersData {
    constructor(data) {
        var _a, _b, _c, _d, _e, _f;
        this.isCompleted = false;
        this.idSession = (_a = data.idSession) !== null && _a !== void 0 ? _a : '';
        this.transactionId = (_b = data.transactionId) !== null && _b !== void 0 ? _b : '';
        this.locationInfo = data.locationInfo ? new LocationInfo(data.locationInfo) : new LocationInfo({});
        this.searchId = (_c = data.searchId) !== null && _c !== void 0 ? _c : '';
        this.totalSearchs = (_d = data.totalSearchs) !== null && _d !== void 0 ? _d : 0;
        this.totalRentalDays = (_e = data.totalRentalDays) !== null && _e !== void 0 ? _e : 0;
        this.results = data.results ? new Results(data.results) : new Results({});
        this.userAnalyzer = data.userAnalyzer ? new UserAnalyzer(data.userAnalyzer) : new UserAnalyzer({});
        this.paging = data.paging ? new Paging(data.paging) : new Paging({});
        this.isCompleted = (_f = data.isCompleted) !== null && _f !== void 0 ? _f : false;
        this.enrichedData = data.enrichedData ? new EnrichedData(data.enrichedData) : new EnrichedData({});
    }
}
export class LocationInfo {
    constructor(data) { }
}
export class Results {
    constructor(data) {
        var _a;
        this.offers = ((_a = data.offers) !== null && _a !== void 0 ? _a : []).map(o => new Offer(o));
    }
}
export class BabySeatOption {
    constructor(data) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        this.babySeatType = (_b = (_a = data.babySeatType) !== null && _a !== void 0 ? _a : data.seatType) !== null && _b !== void 0 ? _b : 0;
        this.paymentType = (_c = data.paymentType) !== null && _c !== void 0 ? _c : 0;
        this.pricePerUnit = (_e = (_d = data.pricePerUnit) !== null && _d !== void 0 ? _d : data.unitPrice) !== null && _e !== void 0 ? _e : 0;
        this.totalPrice = (_f = data.totalPrice) !== null && _f !== void 0 ? _f : 0;
        this.currency = (_h = (_g = data.currency) !== null && _g !== void 0 ? _g : data.currencyCode) !== null && _h !== void 0 ? _h : '';
        this.maxQuantity = (_j = data.maxQuantity) !== null && _j !== void 0 ? _j : 0;
        this.description = (_k = data.description) !== null && _k !== void 0 ? _k : '';
        this.availableOnly = (_l = data.availableOnly) !== null && _l !== void 0 ? _l : undefined;
        this.isAvailable = (_m = data.isAvailable) !== null && _m !== void 0 ? _m : true;
    }
}
export class Offer {
    constructor(data) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
        this.id = (_a = data.id) !== null && _a !== void 0 ? _a : '';
        this.car = data.car ? new Car(data.car) : new Car({});
        this.carProviderCode = (_b = data.carProviderCode) !== null && _b !== void 0 ? _b : '';
        this.pricesDetail = data.pricesDetail ? new PricesDetail(data.pricesDetail) : new PricesDetail({});
        this.pickUpDateTime = (_c = data.pickUpDateTime) !== null && _c !== void 0 ? _c : '';
        this.returnDateTime = (_d = data.returnDateTime) !== null && _d !== void 0 ? _d : '';
        this.pickUpLocation = data.pickUpLocation ? new PickUpLocation(data.pickUpLocation) : new PickUpLocation({});
        this.returnLocation = data.returnLocation ? new ReturnLocation(data.returnLocation) : new ReturnLocation({});
        this.searchOrigin = (_e = data.searchOrigin) !== null && _e !== void 0 ? _e : '';
        this.allowUpselling = (_f = data.allowUpselling) !== null && _f !== void 0 ? _f : false;
        this.includedRemitanceFee = (_g = data.includedRemitanceFee) !== null && _g !== void 0 ? _g : false;
        this.includesMinimumInsurances = (_h = data.includesMinimumInsurances) !== null && _h !== void 0 ? _h : false;
        this.searchDate = (_j = data.searchDate) !== null && _j !== void 0 ? _j : '';
        this.misteryCar = (_k = data.misteryCar) !== null && _k !== void 0 ? _k : false;
        this.totalRentDays = (_l = data.totalRentDays) !== null && _l !== void 0 ? _l : 0;
        this.renter = data.renter ? new Renter(data.renter) : new Renter({});
        this.renters = (_m = data.renters) !== null && _m !== void 0 ? _m : [];
        this.bestSeller = (_o = data.bestSeller) !== null && _o !== void 0 ? _o : false;
        this.status = (_p = data.status) !== null && _p !== void 0 ? _p : 0;
        this.tags = ((_q = data.tags) !== null && _q !== void 0 ? _q : []).map(t => new Tag(t));
        this.locationType = data.locationType ? new LocationType(data.locationType) : new LocationType({});
        this.market = (_r = data.market) !== null && _r !== void 0 ? _r : '';
        const raw = data;
        this.babySeatOptions = ((_v = (_u = (_t = (_s = raw.babySeatOptions) !== null && _s !== void 0 ? _s : raw.babySeatAddOns) !== null && _t !== void 0 ? _t : raw.babySeatAddons) !== null && _u !== void 0 ? _u : raw.babySeats) !== null && _v !== void 0 ? _v : []).map((b) => new BabySeatOption(b));
    }
}
export class Car {
    constructor(data) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        this.sippCode = (_a = data.sippCode) !== null && _a !== void 0 ? _a : '';
        this.specifications = data.specifications ? new Specifications(data.specifications) : new Specifications({});
        this.imageHref = (_b = data.imageHref) !== null && _b !== void 0 ? _b : '';
        this.model = (_c = data.model) !== null && _c !== void 0 ? _c : '';
        this.mainImage = (_d = data.mainImage) !== null && _d !== void 0 ? _d : '';
        this.name = (_e = data.name) !== null && _e !== void 0 ? _e : '';
        this.category = (_f = data.category) !== null && _f !== void 0 ? _f : 0;
        this.size = (_g = data.size) !== null && _g !== void 0 ? _g : 0;
        this.sizeName = (_h = data.sizeName) !== null && _h !== void 0 ? _h : '';
        const parseCsvUrls = (value) => value
            .split(/,(?=\s*https?:\/\/)/i)
            .map((url) => url.trim().replace(/^"+|"+$/g, ""))
            .filter(Boolean);
        const normalizeImagesInput = (value) => {
            if (Array.isArray(value))
                return value;
            if (typeof value === "string")
                return parseCsvUrls(value);
            return [];
        };
        const rawImages = normalizeImagesInput(data.images);
        this.images = rawImages.map((image) => typeof image === "string"
            ? new Image({ type: "image", url: image })
            : new Image(image));
        this.categories = (_j = data.categories) !== null && _j !== void 0 ? _j : [];
    }
}
export class Specifications {
    constructor(data) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.transmission = (_a = data.transmission) !== null && _a !== void 0 ? _a : '';
        this.hasAirConditioned = (_b = data.hasAirConditioned) !== null && _b !== void 0 ? _b : false;
        this.totalPassengers = (_c = data.totalPassengers) !== null && _c !== void 0 ? _c : 0;
        this.numberOfDoors = (_d = data.numberOfDoors) !== null && _d !== void 0 ? _d : 0;
        this.totalBaggages = (_e = data.totalBaggages) !== null && _e !== void 0 ? _e : 0;
        this.androidAuto = (_f = data.androidAuto) !== null && _f !== void 0 ? _f : false;
        this.appleCarPlay = (_g = data.appleCarPlay) !== null && _g !== void 0 ? _g : false;
        this.unlimitedMileage = (_h = data.unlimitedMileage) !== null && _h !== void 0 ? _h : false;
    }
}
export class Image {
    constructor(data) {
        var _a, _b, _c, _d;
        this.type = (_a = data.type) !== null && _a !== void 0 ? _a : '';
        this.url = (_b = data.url) !== null && _b !== void 0 ? _b : '';
        this.images = (_c = data.images) !== null && _c !== void 0 ? _c : [];
        this.videoURL = (_d = data.videoURL) !== null && _d !== void 0 ? _d : '';
    }
}
export class PricesDetail {
    constructor(data) {
        var _a;
        this.currency = ((_a = data.currency) !== null && _a !== void 0 ? _a : []).map(c => new Currency(c));
    }
}
export class Currency {
    constructor(data) {
        var _a, _b, _c, _d, _e;
        this.typeCurrency = (_a = data.typeCurrency) !== null && _a !== void 0 ? _a : '';
        this.total = data.total ? new Total(data.total) : new Total({});
        this.daily = data.daily ? new Daily(data.daily) : new Daily({});
        this.weekly = data.weekly ? new Weekly(data.weekly) : new Weekly({});
        this.items = (_b = data.items) !== null && _b !== void 0 ? _b : [];
        this.informations = (_c = data.informations) !== null && _c !== void 0 ? _c : [];
        this.carProviderCode = (_d = data.carProviderCode) !== null && _d !== void 0 ? _d : '';
        this.rateType = (_e = data.rateType) !== null && _e !== void 0 ? _e : 0;
    }
}
export class Total {
    constructor(data) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.baseAmount = (_a = data.baseAmount) !== null && _a !== void 0 ? _a : 0;
        this.amount = (_b = data.amount) !== null && _b !== void 0 ? _b : 0;
        this.discount = (_c = data.discount) !== null && _c !== void 0 ? _c : 0;
        this.taxes = (_d = data.taxes) !== null && _d !== void 0 ? _d : 0;
        this.discountDisplayValue = (_e = data.discountDisplayValue) !== null && _e !== void 0 ? _e : 0;
        this.extraCharges = (_f = data.extraCharges) !== null && _f !== void 0 ? _f : 0;
        this.renterAmount = (_g = data.renterAmount) !== null && _g !== void 0 ? _g : 0;
        this.extraChargeDetail = ((_h = data.extraChargeDetail) !== null && _h !== void 0 ? _h : []).map(e => new ExtraChargeDetail(e));
    }
}
export class ExtraChargeDetail {
    constructor(data) {
        var _a, _b;
        this.type = (_a = data.type) !== null && _a !== void 0 ? _a : 0;
        this.amount = (_b = data.amount) !== null && _b !== void 0 ? _b : 0;
    }
}
export class Daily {
    constructor(data) {
        var _a, _b;
        this.amount = (_a = data.amount) !== null && _a !== void 0 ? _a : 0;
        this.quantity = (_b = data.quantity) !== null && _b !== void 0 ? _b : 0;
    }
}
export class Weekly {
    constructor(data) {
        var _a, _b;
        this.amount = (_a = data.amount) !== null && _a !== void 0 ? _a : 0;
        this.quantity = (_b = data.quantity) !== null && _b !== void 0 ? _b : 0;
    }
}
export class PickUpLocation {
    constructor(data) {
        var _a, _b, _c;
        this.locationCode = (_a = data.locationCode) !== null && _a !== void 0 ? _a : '';
        this.locationName = (_b = data.locationName) !== null && _b !== void 0 ? _b : '';
        this.atAirport = (_c = data.atAirport) !== null && _c !== void 0 ? _c : false;
    }
}
export class ReturnLocation {
    constructor(data) {
        var _a, _b, _c;
        this.locationCode = (_a = data.locationCode) !== null && _a !== void 0 ? _a : '';
        this.locationName = (_b = data.locationName) !== null && _b !== void 0 ? _b : '';
        this.atAirport = (_c = data.atAirport) !== null && _c !== void 0 ? _c : false;
    }
}
export class Renter {
    constructor(data) {
        var _a, _b, _c, _d, _e, _f, _g;
        this.renterCode = (_a = data.renterCode) !== null && _a !== void 0 ? _a : '';
        this.renterName = (_b = data.renterName) !== null && _b !== void 0 ? _b : '';
        this.image = (_c = data.image) !== null && _c !== void 0 ? _c : '';
        this.rating = (_d = data.rating) !== null && _d !== void 0 ? _d : 0;
        this.certifiedPartner = (_e = data.certifiedPartner) !== null && _e !== void 0 ? _e : false;
        this.rateQualifier = ((_f = data.rateQualifier) !== null && _f !== void 0 ? _f : []).map(r => new RateQualifier(r));
        this.urlPartner = (_g = data.urlPartner) !== null && _g !== void 0 ? _g : '';
    }
}
export class RateQualifier {
    constructor(data) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        this.code = (_a = data.code) !== null && _a !== void 0 ? _a : '';
        this.name = (_b = data.name) !== null && _b !== void 0 ? _b : '';
        this.mobileOnly = (_c = data.mobileOnly) !== null && _c !== void 0 ? _c : false;
        this.market = (_d = data.market) !== null && _d !== void 0 ? _d : '';
        this.voucher = (_e = data.voucher) !== null && _e !== void 0 ? _e : false;
        this.onlyPrepay = (_f = data.onlyPrepay) !== null && _f !== void 0 ? _f : false;
        this.onlyOnDestination = (_g = data.onlyOnDestination) !== null && _g !== void 0 ? _g : false;
        this.summaryDetails = ((_h = data.summaryDetails) !== null && _h !== void 0 ? _h : []).map(s => new SummaryDetail(s));
        this.generalDetails = ((_j = data.generalDetails) !== null && _j !== void 0 ? _j : []).map(g => new GeneralDetail(g));
        this.rateType = (_k = data.rateType) !== null && _k !== void 0 ? _k : 0;
        this.isNetRate = (_l = data.isNetRate) !== null && _l !== void 0 ? _l : false;
        this.netRatePercentage = data.netRatePercentage;
        this.discountNumbers = ((_m = data.discountNumbers) !== null && _m !== void 0 ? _m : []).map(d => new DiscountNumber(d));
        this.groupRate = (_o = data.groupRate) !== null && _o !== void 0 ? _o : '';
        this.status = (_p = data.status) !== null && _p !== void 0 ? _p : false;
        this.country = (_q = data.country) !== null && _q !== void 0 ? _q : '';
        this.sourceCountry = (_r = data.sourceCountry) !== null && _r !== void 0 ? _r : '';
        this.iAtaCode = (_s = data.iAtaCode) !== null && _s !== void 0 ? _s : '';
        this.voucherCodes = data.voucherCodes;
    }
}
export class SummaryDetail {
    constructor(data) {
        var _a, _b, _c, _d, _e, _f, _g;
        this.name = (_a = data.name) !== null && _a !== void 0 ? _a : '';
        this.note = (_b = data.note) !== null && _b !== void 0 ? _b : '';
        this.code = (_c = data.code) !== null && _c !== void 0 ? _c : '';
        this.status = (_d = data.status) !== null && _d !== void 0 ? _d : false;
        this.extraLabel = (_e = data.extraLabel) !== null && _e !== void 0 ? _e : '';
        this.blockByIp = (_f = data.blockByIp) !== null && _f !== void 0 ? _f : false;
        this.translate = (_g = data.translate) !== null && _g !== void 0 ? _g : [];
    }
}
export class GeneralDetail {
    constructor(data) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.name = (_a = data.name) !== null && _a !== void 0 ? _a : '';
        this.note = (_b = data.note) !== null && _b !== void 0 ? _b : '';
        this.code = (_c = data.code) !== null && _c !== void 0 ? _c : '';
        this.status = (_d = data.status) !== null && _d !== void 0 ? _d : false;
        this.category = (_e = data.category) !== null && _e !== void 0 ? _e : '';
        this.extraLabel = (_f = data.extraLabel) !== null && _f !== void 0 ? _f : '';
        this.blockByIp = (_g = data.blockByIp) !== null && _g !== void 0 ? _g : false;
        this.translate = (_h = data.translate) !== null && _h !== void 0 ? _h : [];
    }
}
export class DiscountNumber {
    constructor(data) {
        var _a, _b, _c, _d, _e, _f;
        this.name = (_a = data.name) !== null && _a !== void 0 ? _a : '';
        this.code = (_b = data.code) !== null && _b !== void 0 ? _b : '';
        this.status = (_c = data.status) !== null && _c !== void 0 ? _c : false;
        this.mobile = (_d = data.mobile) !== null && _d !== void 0 ? _d : false;
        this.landing = (_e = data.landing) !== null && _e !== void 0 ? _e : false;
        this.promotion = (_f = data.promotion) !== null && _f !== void 0 ? _f : false;
    }
}
export class Tag {
    constructor(data) {
        var _a, _b, _c, _d, _e;
        this.key = (_a = data.key) !== null && _a !== void 0 ? _a : '';
        this.value = (_b = data.value) !== null && _b !== void 0 ? _b : '';
        this.cssClass = (_c = data.cssClass) !== null && _c !== void 0 ? _c : '';
        this.icon = (_d = data.icon) !== null && _d !== void 0 ? _d : '';
        this.markets = ((_e = data.markets) !== null && _e !== void 0 ? _e : []).map(m => new Market(m));
        this.cssStyles = data.cssStyles;
    }
}
export class Market {
    constructor(data) {
        var _a, _b, _c;
        this.countries = (_a = data.countries) !== null && _a !== void 0 ? _a : '';
        this.translate = ((_b = data.translate) !== null && _b !== void 0 ? _b : []).map(t => new Translate(t));
        this.markets = (_c = data.markets) !== null && _c !== void 0 ? _c : [];
    }
}
export class Translate {
    constructor(data) {
        var _a, _b, _c, _d;
        this.value = (_a = data.value) !== null && _a !== void 0 ? _a : '';
        this.translate = (_b = data.translate) !== null && _b !== void 0 ? _b : [];
        this.language = (_c = data.language) !== null && _c !== void 0 ? _c : '';
        this.markets = (_d = data.markets) !== null && _d !== void 0 ? _d : [];
    }
}
export class LocationType {
    constructor(data) {
        var _a, _b, _c, _d, _e;
        this.key = (_a = data.key) !== null && _a !== void 0 ? _a : '';
        this.value = (_b = data.value) !== null && _b !== void 0 ? _b : '';
        this.cssClass = (_c = data.cssClass) !== null && _c !== void 0 ? _c : '';
        this.icon = (_d = data.icon) !== null && _d !== void 0 ? _d : '';
        this.markets = (_e = data.markets) !== null && _e !== void 0 ? _e : [];
    }
}
export class UserAnalyzer {
    constructor(data) {
        var _a, _b;
        this.applyDiscount = (_a = data.applyDiscount) !== null && _a !== void 0 ? _a : false;
        this.stackValidation = (_b = data.stackValidation) !== null && _b !== void 0 ? _b : '';
    }
}
export class EnrichedData {
    constructor(data) {
        var _a, _b, _c, _d;
        this.email = (_a = data.email) !== null && _a !== void 0 ? _a : '';
        this.fullName = (_b = data.fullName) !== null && _b !== void 0 ? _b : '';
        this.phoneNumber = (_c = data.phoneNumber) !== null && _c !== void 0 ? _c : '';
        this.image = (_d = data.image) !== null && _d !== void 0 ? _d : '';
    }
}
export class Paging {
    constructor(data) {
        var _a, _b, _c, _d;
        this.pageNumber = (_a = data.pageNumber) !== null && _a !== void 0 ? _a : 0;
        this.pageSize = (_b = data.pageSize) !== null && _b !== void 0 ? _b : 0;
        this.totalItems = (_c = data.totalItems) !== null && _c !== void 0 ? _c : 0;
        this.totalPages = (_d = data.totalPages) !== null && _d !== void 0 ? _d : 0;
    }
}
